<div fxFlex fxFill fxLayout="column">

  <div class="spinner-container" *ngIf="dataSource?.isLoading | async">
    <mat-spinner [diameter]="40"></mat-spinner>
  </div>

  <!-- primeiro carregamento (opt-in): reserva altura para o conteúdo abaixo da tabela não aparecer e depois pular -->
  <div class="mat-white-bg" [class.table-initial-loading]="reserveSpaceOnFirstLoad && !firstLoadDone">
    <table mat-table #table [dataSource]="dataSource" [@animateStagger]="{value:'50'}"
    [style.display]="!(dataSource?.isLoading | async) && (dataSource?.isEmpty | async) ? 'none' : ''">
      <ng-content></ng-content>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"
        [hidden]="!(dataSource?.isLoading | async) && (dataSource?.isEmpty | async)"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns; trackBy: trackBy" matRipple (click)="onSelectedRowInternal(row)"
        [hidden]="!(dataSource?.isLoading | async) && (dataSource?.isEmpty | async)"></tr>
    </table>

    <ng-container *ngIf="!(dataSource?.isLoading | async)">
      <div *ngIf="(dataSource?.isEmpty | async) && !emptyTemplate" class="no-records">
        {{emptyLabel}}
      </div>

      <ng-container *ngIf="(dataSource?.isEmpty | async) && emptyTemplate">
        <ng-container *ngTemplateOutlet="emptyTemplate"></ng-container>
      </ng-container>
    </ng-container>

  </div>


  <!-- O style.display='none' só será executado quando não estiver carregando e não exitir itens para serem exibidos -->
  <!-- No primeiro carregamento (opt-in) o paginador fica invisível, mas ocupando espaço: assim ele
       não aparece colado ao cabeçalho e depois "pula" quando as linhas chegam -->
  <mat-paginator
    [style.display]="!(dataSource?.isLoading | async) && (dataSource?.isEmpty | async) && emptyTemplate ? 'none' : ''"
    [style.visibility]="reserveSpaceOnFirstLoad && !firstLoadDone ? 'hidden' : ''"
    [length]="dataSource?.totalItems | async" [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize"
    (page)="handlePageEvent($event)">
  </mat-paginator>


</div>
